const removeEmptyStrings = (obj) => {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([_, v]) => v !== '')
      .map(([k, v]) => [k, v === Object(v) ? removeEmptyStrings(v) : v]),
  );
};

export default removeEmptyStrings;
